export default __webpack_public_path__ + "static/media/perfume_one_day_mobile.040aa746.jpg";